import React, { Component } from "react";
import ClearFilterButton from "../../components/ClearFilterButton.js";
import { technicianSelectProps } from "../../utils/technicianFilter.js";
import {
  loading,
  alert,
  NavbarAdmin,
  Pagination,
  DateRangeFields,
  Select,
  GET,
  GET_FILE,
  PUT,
  PATCH,
  saveAs,
  profile,
  currentLang,
  t,
  Modal,
} from "../../components/CustomComponent.js";
import {
  currentWeekRange,
  validateRange,
  fmtDayMonth,
  fmtDateLocal,
  fmtTime,
  fmtDateTime,
  fmtDayMonthTime,
  fmtMinutes,
  mapUrl,
  pruneParams,
  hasPermission,
} from "../../utils/timeTracking.js";
import "../../assets/css/time-tracking.css";

import { formatNumber } from "../../utils/formatting";
const PAGE_SIZE = 20;
const Q_DEBOUNCE_MS = 400;

// ลำดับตัวเลือกสถานะตามต้นแบบ
const STATUS_OPTIONS = ["complete", "working", "no_checkout", "absent", "low_accuracy", "corrected"];
const STATUS_BADGE = {
  complete: "out",
  working: "in",
  no_checkout: "crit",
  absent: "none",
  low_accuracy: "warn",
  corrected: "p",
};
const REQUEST_BADGE = { pending: "warn", approved: "in", rejected: "crit", cancelled: "none" };
const CORRECTION_TYPES = ["miss_out", "miss_in", "wrong_time", "cannot_log"];
const REQUEST_STATUS_OPTIONS = ["pending", "approved", "rejected", "cancelled", "all"];
const REJECT_REASON_CODES = ["no_evidence", "mismatch_wo", "need_new_time", "overdue", "other"];
const SETTING_MAX = { accuracy_threshold_m: 10000, auto_close_hours: 72, correction_backdate_days: 90 };
// ตั้งค่าแจ้งเตือนเตือนหัวหน้า (reminder) - min/max ของแต่ละช่อง (เวลาเตือน 0-23 ชม. เวลาไทย)
const REMINDER_RANGE = { reminder_after_workdays: [1, 30], reminder_hour: [0, 23] };

// หน้า "ลงเวลาเข้า-ออก" ของแอดมิน - field ตรงกับ SNAPA-Backend modules/admin/attendance (dtos/response)
//   GET   admin/attendance                 -> data={view, rows, kpi} + pagination
//   GET   admin/attendance/:uid            -> data={log, history[], corrections[]}
//   GET   admin/attendance/export          -> xlsx (GET_FILE เพราะเป็น binary)
//   GET   admin/attendance/corrections     -> data={rows, pending_count}
//   PATCH admin/attendance/corrections/:uid {action, reject_reason?}
//   PUT   admin/attendance/:uid/override  {check_in_at|null, check_out_at|null, reason} (attendance.override)
//   GET/PUT admin/attendance/settings
export default class AdminAttendance extends Component {
  constructor(props) {
    super(props);
    const week = currentWeekRange();
    this.can = {
      export: hasPermission(profile, "attendance.export"),
      approve: hasPermission(profile, "attendance.approve"),
      setting: hasPermission(profile, "attendance.setting"),
      override: hasPermission(profile, "attendance.override"),
    };
    this.req_q_timer = null;
    this.state = {
      tab: "report",

      // รายงาน
      filter_from: week.from,
      filter_to: week.to,
      filter_department_uid: "",
      filter_technician_uid: "",
      filter_status: "",
      view: "list",
      data: [],
      data_view: "list", // มุมมองที่ data ชุดนี้เป็นของ
      kpi: null,
      totals: null,
      count: 0,
      page: 1,
      data_departments: [],
      data_technicians: [],
      detail: null,

      // คำขอแก้ไขเวลา
      req_status: "pending",
      req_from: "",
      req_to: "",
      req_q: "",
      req_data: [],
      pending_count: 0,
      modal_reject: false,
      reject_item: null,
      reject_reason: "",

      // HR แก้เวลาแทน
      modal_override: false,
      override_in: "",
      override_out: "",
      override_reason: "",
      override_out_next: false, // เวลาออกเป็นวันถัดไปจากวันที่ลงเวลา
      override_orig: { in: "", out: "", next: false }, // ค่าเดิมที่แสดงตอนเปิด modal ใช้เทียบว่าช่องไหนเปลี่ยนจริง

      // ตั้งค่า
      settings: { accuracy_threshold_m: "", auto_close_hours: "", correction_backdate_days: "", reminder_enabled: true, reminder_after_workdays: "", reminder_hour: "" },
      reminder_supported: false, // backend ส่ง reminder_* มาหรือยัง (ยังไม่มี = ไม่โชว์/ไม่ส่ง)
    };
  }

  async componentDidMount() {
    loading(false);
    const dept = await GET("admin/departments", { page_size: 1000, page: 0, data_search: "", scope_department: "true" });
    if (dept?.status && Array.isArray(dept.data)) this.setState({ data_departments: dept.data });
    await this.GetTechnicians();
    this.Get(1);
    this.GetRequests();
  }

  componentWillUnmount() {
    clearTimeout(this.req_q_timer);
  }

  rangeError = (from, to) => {
    const err = validateRange(from, to);
    if (!err) return false;
    alert("", "warning", t("warning"), t(`att_range_${err}`));
    return true;
  };

  buildParams = (extra = {}) => {
    const { filter_from, filter_to, filter_department_uid, filter_technician_uid, filter_status, view } = this.state;
    return pruneParams({
      from: filter_from,
      to: filter_to,
      department_uid: filter_department_uid,
      technician_uid: filter_technician_uid,
      // absent สร้างเฉพาะ view=list (สรุปรายบุคคลไม่รองรับ) จึงไม่ส่งสถานะตอนดูสรุป
      status: view === "list" ? filter_status : "",
      view,
      ...extra,
    });
  };

  // ---------------------------------------------------------------- รายงาน
  Get = async (page = 1) => {
    const { filter_from, filter_to } = this.state;
    if (this.rangeError(filter_from, filter_to)) return;

    loading(true);
    const result = await GET("admin/attendance", this.buildParams({ page, limit: PAGE_SIZE }));

    if (result?.status) {
      const rows = result.data?.rows || [];
      this.setState({ data: rows, data_view: this.state.view, kpi: result.data?.kpi || null, totals: result.data?.totals || null, count: result.pagination?.count ?? rows.length, page, detail: null });
    } else {
      this.setState({ data: [], kpi: null, count: 0, page, detail: null });
    }
    loading(false);
  };

  // ตัวกรองทำงานทันทีที่เปลี่ยนค่า (ตามต้นแบบ) ไม่มีปุ่มค้นหา
  SetFilter = (patch) => this.setState(patch, () => this.Get(1));

  // รายชื่อช่างสำหรับ dropdown พนักงาน (backend กรองตามสิทธิ์แผนกของผู้ใช้แล้ว)
  GetTechnicians = async () => {
    const result = await GET("admin/attendance/filter-options");
    if (result?.status && result.data) this.setState({ data_technicians: result.data.technicians || [] });
  };

  // เปลี่ยนแผนก -> พนักงานกลับเป็น "ทั้งหมดในแผนก"
  ChangeDepartment = (departmentUid) => this.SetFilter({ filter_department_uid: departmentUid || "", filter_technician_uid: "" });

  ResetFilter = () => {
    const week = currentWeekRange();
    this.SetFilter({ filter_from: week.from, filter_to: week.to, filter_department_uid: "", filter_technician_uid: "", filter_status: "" });
  };

  SetView = (view) => {
    if (view !== this.state.view) this.SetFilter({ view });
  };

  Export = async () => {
    const { filter_from, filter_to } = this.state;
    if (this.rangeError(filter_from, filter_to)) return;

    loading(true);
    const result = await GET_FILE("admin/attendance/export", this.buildParams());
    if (result?.status && result.blob) {
      saveAs(result.blob, `attendance_${filter_from}_${filter_to}.xlsx`);
    } else {
      alert("", "warning", t("warning"), result?.message || t("att_export_failed"));
    }
    loading(false);
  };

  ExportTxt = async () => {
    const { filter_from, filter_to } = this.state;
    if (this.rangeError(filter_from, filter_to)) return;

    loading(true);
    const result = await GET_FILE("admin/attendance/export-txt", this.buildParams());
    if (result?.status && result.blob) {
      saveAs(result.blob, `attendance_${filter_from}_${filter_to}.txt`);
    } else {
      alert("", "warning", t("warning"), result?.message || t("att_export_failed"));
    }
    loading(false);
  };

  OpenDetail = async (uid) => {
    if (!uid) return;
    loading(true);
    const result = await GET("admin/attendance/" + uid);
    if (result?.status) {
      this.setState({ detail: result.data }, () => this.drawer_ref?.scrollIntoView?.({ behavior: "smooth", block: "nearest" }));
    } else {
      alert("", "warning", t("warning"), result?.message || t("att_detail_failed"));
    }
    loading(false);
  };

  // ---------------------------------------------------------------- คำขอแก้ไขเวลา
  GetRequests = async () => {
    const { req_status, req_from, req_to, req_q } = this.state;
    if (req_from && req_to && req_from > req_to) {
      alert("", "warning", t("warning"), t("att_range_order"));
      return;
    }
    loading(true);
    const result = await GET(
      "admin/attendance/corrections",
      pruneParams({ status: req_status, from: req_from, to: req_to, q: req_q.trim() })
    );
    if (result?.status) {
      this.setState({ req_data: result.data?.rows || [], pending_count: result.data?.web_pending_count ?? result.data?.pending_count ?? 0 });
    } else {
      this.setState({ req_data: [] });
    }
    loading(false);
  };

  // ไฟล์แนบ S3 ตรงเปิดไม่ได้ (403) - ดึงผ่าน backend ด้วย GET_FILE แล้วเปิดเป็น blob URL
  OpenAttachment = async (item) => {
    loading(true);
    const result = await GET_FILE(`admin/attendance/corrections/${item.uid}/attachment`);
    loading(false);
    if (result?.status && result.blob) {
      window.open(URL.createObjectURL(result.blob), "_blank", "noreferrer");
    } else {
      alert("", "warning", t("warning"), result?.message || t("att_attachment_failed"));
    }
  };

  SetReqQ = (value) => {
    this.setState({ req_q: value });
    clearTimeout(this.req_q_timer);
    this.req_q_timer = setTimeout(this.GetRequests, Q_DEBOUNCE_MS);
  };

  Approve = async (item) => {
    if (!(await alert("", "info", t("confirm"), t("att_confirm_approve"), t("confirm"), t("cancel")))) return;
    loading(true);
    const result = await PATCH("admin/attendance/corrections/" + item.uid, { action: "approve" });
    if (result?.status) {
      alert("", "success", t("success"), result.data?.forwarded ? t("att_forward_success") : t("att_approve_success"));
      await this.GetRequests();
      this.Get(this.state.page);
    } else {
      alert("", "warning", t("warning"), result?.message || "An error occurred.");
    }
    loading(false);
  };

  OpenReject = (item) => this.setState({ modal_reject: true, reject_item: item, reject_reason: "" });

  Reject = async () => {
    const { reject_item, reject_reason } = this.state;
    if (!reject_reason.trim()) {
      alert("", "warning", t("warning"), t("att_reject_reason_required"));
      return;
    }
    loading(true);
    const result = await PATCH("admin/attendance/corrections/" + reject_item.uid, {
      action: "reject",
      reject_reason: reject_reason.trim(),
    });
    if (result?.status) {
      this.setState({ modal_reject: false, reject_item: null, reject_reason: "" });
      alert("", "success", t("success"), t("att_reject_success"));
      await this.GetRequests();
    } else {
      alert("", "warning", t("warning"), result?.message || "An error occurred.");
    }
    loading(false);
  };

  // ---------------------------------------------------------------- HR แก้เวลาแทน
  // log ของตัวเองแก้ไม่ได้ (backend 403 อีกชั้น) - เทียบรหัสช่างเมื่อ profile มี
  isOwnLog = (log) => {
    const code = profile?.technician_code || profile?.technician?.technician_code;
    const uid = profile?.technician_uid || profile?.technician?.uid;
    return !!((code && log?.technician?.code === code) || (uid && log?.technician?.uid === uid));
  };

  OpenOverride = () => {
    const log = this.state.detail?.log;
    if (!log) return;
    const inVal = log.check_in_at ? fmtTime(log.check_in_at) : "";
    const outVal = log.check_out_at ? fmtTime(log.check_out_at) : "";
    // วันที่ (เวลาไทย) ของเวลาออกเดิม เทียบกับ work_date
    const next = !!log.check_out_at && this.thaiDate(log.check_out_at) > String(log.work_date).slice(0, 10);
    this.setState({
      modal_override: true,
      override_in: inVal,
      override_out: outVal,
      override_out_next: next,
      override_orig: { in: inVal, out: outVal, next },
      override_reason: "",
    });
  };

  thaiDate = (iso) => new Date(new Date(iso).getTime() + 7 * 3600 * 1000).toISOString().slice(0, 10);

  addDays = (ymd, n) => {
    const [y, m, d] = ymd.split("-").map(Number);
    return new Date(Date.UTC(y, m - 1, d + n)).toISOString().slice(0, 10);
  };

  // เวลา HH:mm (เวลาไทย) + วันที่ลงเวลา -> ISO พร้อม offset
  toOverrideIso = (workDate, hhmm, dayOffset = 0) =>
    hhmm ? `${this.addDays(String(workDate).slice(0, 10), dayOffset)}T${hhmm}:00+07:00` : null;

  SaveOverride = async () => {
    const { detail, override_in, override_out, override_out_next, override_orig, override_reason } = this.state;
    const log = detail?.log;
    if (!log) return;
    // ส่งเฉพาะช่องที่ HR เปลี่ยนจริง (ช่องที่ไม่เปลี่ยน = null backend ใช้ค่าเดิม)
    const inChanged = !!override_in && override_in !== override_orig.in;
    const outChanged = !!override_out && (override_out !== override_orig.out || override_out_next !== override_orig.next);
    if (!inChanged && !outChanged) {
      alert("", "warning", t("warning"), t("att_override_need_any"));
      return;
    }
    if (!override_reason.trim()) {
      alert("", "warning", t("warning"), t("att_override_reason_required"));
      return;
    }
    loading(true);
    const result = await PUT(`admin/attendance/${log.uid}/override`, {
      check_in_at: inChanged ? this.toOverrideIso(log.work_date, override_in) : null,
      check_out_at: outChanged ? this.toOverrideIso(log.work_date, override_out, override_out_next ? 1 : 0) : null,
      reason: override_reason.trim(),
    });
    if (result?.status) {
      this.setState({ modal_override: false });
      alert("", "success", t("success"), t("att_override_success"));
      await this.Get(this.state.page);
      loading(true);
      const refreshed = await GET("admin/attendance/" + log.uid);
      if (refreshed?.status) this.setState({ detail: refreshed.data });
    } else {
      alert("", "warning", t("warning"), result?.message || "An error occurred.");
    }
    loading(false);
  };

  // ---------------------------------------------------------------- ตั้งค่า
  GetSettings = async () => {
    loading(true);
    const result = await GET("admin/attendance/settings");
    if (result?.status && result.data) {
      const { accuracy_threshold_m, auto_close_hours, correction_backdate_days, reminder_enabled, reminder_after_workdays, reminder_hour } = result.data;
      const reminder_supported = reminder_enabled !== undefined;
      this.setState({
        settings: {
          accuracy_threshold_m,
          auto_close_hours,
          correction_backdate_days,
          reminder_enabled: reminder_supported ? !!reminder_enabled : true,
          reminder_after_workdays: reminder_after_workdays ?? "",
          reminder_hour: reminder_hour ?? "",
        },
        reminder_supported,
      });
    }
    loading(false);
  };

  SaveSettings = async () => {
    const { settings, reminder_supported } = this.state;
    const body = {};
    for (const key of Object.keys(SETTING_MAX)) {
      const value = Number(settings[key]);
      if (settings[key] === "" || !Number.isInteger(value) || value < 1 || value > SETTING_MAX[key]) {
        alert("", "warning", t("warning"), t("att_settings_invalid"));
        return;
      }
      body[key] = value;
    }
    if (reminder_supported) {
      body.reminder_enabled = !!settings.reminder_enabled;
      for (const [key, [min, max]] of Object.entries(REMINDER_RANGE)) {
        const value = Number(settings[key]);
        if (settings[key] === "" || !Number.isInteger(value) || value < min || value > max) {
          alert("", "warning", t("warning"), t("att_reminder_invalid"));
          return;
        }
        body[key] = value;
      }
    }
    if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await PUT("admin/attendance/settings", body);
    if (result?.status) {
      alert("", "success", t("success"), t("save_success"));
    } else {
      alert("", "warning", t("warning"), result?.message || "An error occurred.");
    }
    loading(false);
  };

  SwitchTab = (tab) => {
    this.setState({ tab });
    if (tab === "settings") this.GetSettings();
    if (tab === "requests") this.GetRequests();
  };

  // ---------------------------------------------------------------- render helpers
  badge = (kind, label) => <span className={`tt-badge tt-b-${kind}`}>{label}</span>;

  // พิกัดไม่แม่นยำเป็น flag ของ log ที่สถานะ "ครบ" - ต้นแบบแสดงเป็นป้ายสถานะเดียว "พิกัดไม่แม่นยำ ±N ม."
  renderStatus = (row) => {
    const flagged = Array.isArray(row.flags) && row.flags.includes("low_accuracy");
    const backdate = row.source === "backdate" ? <> {this.badge("p", t("att_backdate_badge"))}</> : null;
    if (flagged && row.status === "complete") {
      return <>{this.badge("warn", `${t("att_status_low_accuracy")}${row.in_accuracy_m ? ` ±${Math.round(row.in_accuracy_m)} ${t("att_meter")}` : ""}`)}{backdate}</>;
    }
    const status = row.status || "absent";
    return <>{this.badge(STATUS_BADGE[status] || "none", t(`att_status_${status}`))}{backdate}</>;
  };

  renderPlace = (address, lat, lng) => {
    const url = mapUrl(lat, lng);
    const label = address || (url ? `${lat}, ${lng}` : null);
    if (!label) return "-";
    return url ? (
      <a href={url} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}>📍 {label}</a>
    ) : (
      label
    );
  };

  renderKpi = () => {
    const { kpi, filter_status, view } = this.state;
    if (!kpi) return null;
    // 6 การ์ดตามต้นแบบ คลิกเพื่อกรองตามสถานะ
    const cards = [
      { key: "total_rows", label: t("att_kpi_total_rows"), value: kpi.total_rows, status: "", color: "var(--tt-ink)" },
      { key: "complete", label: t("att_status_complete"), value: kpi.complete, status: "complete", color: "var(--tt-brand)" },
      { key: "working", label: t("att_kpi_working"), value: kpi.working, status: "working", color: "var(--tt-ok)" },
      { key: "no_checkout", label: t("att_kpi_no_checkout"), value: kpi.no_checkout, status: "no_checkout", color: "var(--tt-crit)" },
      { key: "not_checked_in", label: t("att_status_absent"), value: kpi.not_checked_in, status: "absent", color: "var(--tt-ink-soft)" },
      { key: "low_accuracy", label: t("att_kpi_low_accuracy"), value: kpi.low_accuracy, status: "low_accuracy", color: "var(--tt-warn)" },
    ];
    return (
      <div className="tt-kpis">
        {cards.map((c) => (
          <div
            key={c.key}
            className={`tt-kpi ${c.static ? "static" : ""} ${!c.static && c.status === filter_status ? "sel" : ""}`}
            onClick={() => !c.static && view === "list" && this.SetFilter({ filter_status: c.status })}
          >
            <small>{c.label}</small>
            <b style={{ color: c.color }}>{formatNumber(c.value ?? 0)}</b>
          </div>
        ))}
      </div>
    );
  };

  viewData = () => (this.state.data_view === this.state.view ? this.state.data : []);

  renderListTable = () => {
    const data = this.viewData();
    return (
      <table className="tt-tbl" style={{ minWidth: 1100 }}>
        <thead>
          <tr>
            <th>{t("date")}</th>
            <th>{t("code")}</th>
            <th>{t("name")}</th>
            <th>{t("department")}</th>
            <th>{t("att_col_in")}</th>
            <th>{t("att_col_in_place")}</th>
            <th>{t("att_col_out")}</th>
            <th>{t("att_col_out_place")}</th>
            <th className="num">{t("att_col_total")}</th>
            <th>{t("status")}</th>
          </tr>
        </thead>
        <tbody>
          {!data.length ? (
            <tr><td colSpan="10" className="text-center text-secondary py-5">{t("no_data")}</td></tr>
          ) : (
            data.map((r, i) => (
              <tr key={r.uid || `${r.work_date}-${r.technician?.uid}-${i}`} className={r.uid ? "click" : ""} onClick={() => this.OpenDetail(r.uid)}>
                <td>{fmtDayMonth(r.work_date)}</td>
                <td className="tt-mono"><b>{r.technician?.code || "-"}</b></td>
                <td>{r.technician?.name || "-"}</td>
                <td>{r.department_name || "-"}</td>
                <td className="tt-mono"><b>{fmtTime(r.check_in_at)}</b></td>
                <td>{this.renderPlace(r.in_address, r.in_latitude, r.in_longitude)}</td>
                <td className="tt-mono"><b>{fmtTime(r.check_out_at)}</b>{r.corrected_at && r.check_out_at ? "*" : ""}</td>
                <td>{this.renderPlace(r.out_address, r.out_latitude, r.out_longitude)}</td>
                <td className="num tt-mono">{r.total_minutes ? fmtMinutes(r.total_minutes) : "-"}</td>
                <td>{this.renderStatus(r)}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    );
  };

  renderPersonTable = () => {
    const data = this.viewData();
    const { totals } = this.state;
    return (
      <table className="tt-tbl" style={{ minWidth: 900 }}>
        <thead>
          <tr>
            <th>{t("code")}</th>
            <th>{t("name")}</th>
            <th>{t("department")}</th>
            <th className="num">{t("att_col_days")}</th>
            <th className="num">{t("att_col_total_hours")}</th>
            <th className="num">{t("att_col_avg")}</th>
            <th className="num">{t("att_col_absent_days")}</th>
            <th className="num">{t("att_col_abnormal")}</th>
          </tr>
        </thead>
        <tbody>
          {!data.length ? (
            <tr><td colSpan="8" className="text-center text-secondary py-5">{t("no_data")}</td></tr>
          ) : (
            data.map((r, i) => (
              <tr key={r.technician?.uid || i} className="click" onClick={() => this.SetFilter({ view: "list", filter_technician_uid: r.technician?.uid || "" })}>
                <td className="tt-mono"><b>{r.technician?.code || "-"}</b></td>
                <td>{r.technician?.name || "-"}</td>
                <td>{r.department_name || "-"}</td>
                <td className="num">{formatNumber(r.days ?? 0)}</td>
                <td className="num tt-mono"><b>{fmtMinutes(r.total_minutes)}</b></td>
                <td className="num tt-mono">{r.days ? fmtMinutes(r.avg_minutes) : "-"}</td>
                <td className="num">{r.absent_days ? formatNumber(r.absent_days) : "-"}</td>
                <td className="num">{r.abnormal_count ? this.badge("crit", formatNumber(r.abnormal_count)) : "-"}</td>
              </tr>
            ))
          )}
          {data.length && totals ? (
            <tr className="tot">
              <td colSpan="3">{t("total")}</td>
              <td className="num">{formatNumber(totals.days)}</td>
              <td className="num tt-mono">{fmtMinutes(totals.total_minutes)}</td>
              <td className="num tt-mono">{totals.days ? fmtMinutes(totals.avg_minutes) : "-"}</td>
              <td className="num">{totals.absent_days ? formatNumber(totals.absent_days) : "-"}</td>
              <td className="num">{formatNumber(totals.abnormal_count)}</td>
            </tr>
          ) : null}
        </tbody>
      </table>
    );
  };

  renderReport() {
    const { view, count, page, data_departments, data_technicians, filter_from, filter_to, filter_department_uid, filter_technician_uid, filter_status } = this.state;

    const data = this.viewData();

    return (
      <>
        <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
          <div className="row g-3 align-items-end">
            <div className="col-md-4">
              <label className="form-label text-12 text-secondary mb-1">{t("date_range")}</label>
              <div className="d-flex gap-2">
                <DateRangeFields
                  type="th"
                  className="form-control"
                  fieldStyle={{ flex: 1, minWidth: 0 }}
                  startPlaceholder={t("start_date")}
                  endPlaceholder={t("end_date")}
                  startValue={filter_from}
                  endValue={filter_to}
                  onChange={({ start, end }) => this.SetFilter({ filter_from: start, filter_to: end })}
                />
              </div>
            </div>
            <div className="col-md-3">
              <label className="form-label text-12 text-secondary mb-1">{t("department")}</label>
              <Select
                className="form-control w-100"
                options={[{ value: "", label: t("all") }, ...data_departments.map((d) => ({ value: d.uid, label: [d.department_code, d.name].filter(Boolean).join(" - ") }))]}
                value={filter_department_uid}
                onChange={(v) => this.ChangeDepartment(v)}
                placeholder={t("all")}
              />
            </div>
            <div className="col-md-3">
              <label className="form-label text-12 text-secondary mb-1">{t("att_filter_employee")}</label>
              <Select
                className="form-control w-100"
                {...technicianSelectProps(data_technicians, filter_department_uid, t)}
                value={filter_technician_uid}
                onChange={(v) => this.SetFilter({ filter_technician_uid: v || "" })}
              />
            </div>
            <div className="col-md-2">
              <label className="form-label text-12 text-secondary mb-1">{t("status")}</label>
              <Select
                className="form-control w-100"
                options={[{ value: "", label: t("all") }, ...STATUS_OPTIONS.map((s) => ({ value: s, label: t(`att_status_${s}`) }))]}
                value={filter_status}
                disabled={view !== "list"}
                onChange={(v) => this.SetFilter({ filter_status: v || "" })}
                placeholder={t("all")}
              />
            </div>
            <div className="col-12 d-flex justify-content-end">
              <ClearFilterButton onClick={this.ResetFilter} />
            </div>
          </div>
        </div>

        {this.renderKpi()}

        <div className="tt-viewbar">
          <div className="tt-seg">
            {["list", "person"].map((v) => (
              <button key={v} type="button" className={view === v ? "on" : ""} onClick={() => this.SetView(v)}>{t(`att_view_${v}`)}</button>
            ))}
          </div>
          <span className="tt-mini">
            {view === "list" ? `${formatNumber(count)} ${t("att_unit_rows")} · ${t("att_click_row_hint")}` : `${formatNumber(count)} ${t("att_unit_people")}`}
          </span>
        </div>

        <div className="tt-tblwrap">{view === "list" ? this.renderListTable() : this.renderPersonTable()}</div>

        <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap tt-mini">
          <div>
            {t("showing")} {data.length ? formatNumber((page - 1) * PAGE_SIZE + 1) : 0}-{formatNumber((page - 1) * PAGE_SIZE + data.length)} {t("of")} {formatNumber(count)}
          </div>
          <Pagination className="mb-0" count={Math.ceil(count / PAGE_SIZE) || 1} page={page} showFirstButton={false} showLastButton={false} onChange={(_, next) => this.Get(next)} />
        </div>

        {this.renderDrawer()}
      </>
    );
  }

  // ค่าใน audit (old_values/new_values) - ISO datetime แสดงเป็นเวลาไทย ค่าอื่นแสดงตามเดิม
  fmtAuditValue = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T/.test(value)) return fmtDateTime(value);
    return typeof value === "object" ? JSON.stringify(value) : String(value);
  };

  // เวลาเดิม "07:55 – ไม่มี" (ไม่มี = สีแดง)
  renderTimePair = (inAt, outAt, bold) => {
    const part = (iso) => (iso ? fmtTime(iso) : <span style={{ color: "var(--tt-crit)" }}>{t("att_none")}</span>);
    return (
      <span style={bold ? { fontWeight: 700 } : undefined}>
        {part(inAt)} – {part(outAt)}
      </span>
    );
  };

  renderMap = (lat, lng) => {
    const url = mapUrl(lat, lng);
    return (
      <div className="tt-map">
        {url ? <iframe title={`map-${lat}-${lng}`} src={`${url}&output=embed`} loading="lazy" /> : <div className="empty">{t("att_no_location")}</div>}
      </div>
    );
  };

  renderDrawer() {
    const { detail } = this.state;
    if (!detail) return null;
    const { log } = detail;
    const history = detail.history || [];
    const corrections = detail.corrections || [];
    const lang = currentLang();
    const mapLink = (lat, lng) => {
      const url = mapUrl(lat, lng);
      return url ? <a href={url} target="_blank" rel="noreferrer">{t("att_open_map")}</a> : null;
    };

    return (
      <Modal show onHide={() => this.setState({ detail: null })} centered size="lg" scrollable contentClassName="border-0 rounded-4 shadow-lg">
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
          <div className="d-flex flex-wrap align-items-center gap-2">
            <h5 className="fw-bold mb-0 text-dark">
              {log.technician?.name || "-"} ({log.technician?.code || "-"}) · {fmtDateLocal(log.work_date, lang)} · {log.department_name || "-"}
            </h5>
            {this.renderStatus(log)}
          </div>
        </Modal.Header>
        <Modal.Body className="p-4 bg-white">
        <div className="tt-dgrid">
          <div>
            <b style={{ color: "var(--tt-ok)" }}>{t("att_detail_in")} {fmtTime(log.check_in_at)}</b>
            {this.renderMap(log.in_latitude, log.in_longitude)}
            <div className="tt-kv">
              <span>{t("att_detail_place")}</span><span>{log.in_address || "-"} {mapLink(log.in_latitude, log.in_longitude)}</span>
              <span>{t("att_detail_coords")}</span><span className="tt-mono">{mapUrl(log.in_latitude, log.in_longitude) ? `${log.in_latitude}, ${log.in_longitude}` : "-"}</span>
              <span>{t("att_detail_accuracy")}</span><span>{log.in_accuracy_m ? `±${Math.round(log.in_accuracy_m)} ${t("att_meter")}` : "-"}</span>
              <span>{t("note")}</span><span>{log.in_note || "-"}</span>
            </div>
          </div>
          <div>
            <b style={{ color: "var(--tt-crit)" }}>{t("att_detail_out")} {fmtTime(log.check_out_at)}</b>
            {this.renderMap(log.out_latitude, log.out_longitude)}
            <div className="tt-kv">
              <span>{t("att_detail_place")}</span><span>{log.out_address || "-"} {mapLink(log.out_latitude, log.out_longitude)}</span>
              <span>{t("att_detail_accuracy")}</span><span>{log.out_accuracy_m ? `±${Math.round(log.out_accuracy_m)} ${t("att_meter")}` : "-"}</span>
              <span>{t("att_col_total")}</span><span className="tt-mono">{log.total_minutes ? fmtMinutes(log.total_minutes) : "-"}</span>
              <span>{t("att_col_wo")}</span><span>{log.wo_count == null ? "-" : formatNumber(log.wo_count)}</span>
              <span>{t("note")}</span><span>{log.out_note || "-"}</span>
              <span>{t("att_detail_history")}</span>
              <span>
                {log.corrected_at
                  ? `${fmtDateTime(log.corrected_at)}${log.corrected_by_name ? ` · ${log.corrected_by_name}` : ""}`
                  : "-"}
              </span>
            </div>
          </div>
        </div>

        {corrections.length ? (
          <div className="mt-3">
            <b>{t("att_detail_corrections")}</b>
            <div className="d-flex flex-column gap-2 mt-2">
              {corrections.map((c) => (
                <div key={c.uid} className="border rounded-3 p-2 text-14" style={{ background: "var(--tt-surface-2)" }}>
                  <div className="d-flex justify-content-between flex-wrap gap-2">
                    <b>{CORRECTION_TYPES.includes(c.type) ? t(`att_type_${c.type}`) : c.type}</b>
                    {this.badge(REQUEST_BADGE[c.status] || "warn", t(`att_req_status_${c.status}`))}
                  </div>
                  <div className="tt-mini mt-1">
                    {this.renderTimePair(c.original_in_at, c.original_out_at)} → {this.renderTimePair(c.req_in_at, c.req_out_at, true)}
                  </div>
                  {c.reason ? <div className="mt-1">{c.reason}</div> : null}
                  {c.reject_reason ? <div className="mt-1" style={{ color: "var(--tt-crit)" }}>{c.reject_reason}</div> : null}
                </div>
              ))}
            </div>
          </div>
        ) : null}

        {history.length ? (
          <div className="mt-3">
            <b>{t("att_detail_history")}</b>
            <div className="d-flex flex-column gap-2 mt-2">
              {history.map((h) => (
                <div key={h.uid} className="border rounded-3 p-2 text-14" style={{ background: "var(--tt-surface-2)" }}>
                  <div className="d-flex justify-content-between flex-wrap gap-2">
                    <b>{h.action || "-"}</b>
                    <span className="tt-mini">{fmtDateTime(h.created_at)}{h.actor_name ? ` · ${h.actor_name}` : ""}</span>
                  </div>
                  {(h.changed_fields || []).map((field) => (
                    <div key={field} className="tt-mini mt-1">
                      {field}: {this.fmtAuditValue(h.old_values?.[field])} → <b style={{ color: "var(--tt-ink)" }}>{this.fmtAuditValue(h.new_values?.[field])}</b>
                    </div>
                  ))}
                  {h.reason ? <div className="tt-mini mt-1">{h.reason}</div> : null}
                </div>
              ))}
            </div>
          </div>
        ) : null}
        </Modal.Body>
        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
          <button type="button" className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ detail: null })}>{t("att_close")}</button>
          {this.can.override && log.uid && !this.isOwnLog(log) ? (
            <button type="button" className="btn btn-primary px-4 py-2 rounded-3 fw-bold" onClick={this.OpenOverride}>✎ {t("att_override_btn")}</button>
          ) : null}
        </Modal.Footer>
      </Modal>
    );
  }

  // เว็บอนุมัติ/ปฏิเสธได้ตาม can_decide_on_web ที่ backend คำนวณจาก approval_scope ของประเภทผู้ใช้
  // (ผู้บังคับบัญชา = แผนก/สายงาน, ผู้บริหาร = ทุกใบ, ใบที่ไม่มีหัวหน้า = ทุกประเภทที่อนุมัติได้) ที่เหลือดูอย่างเดียว
  // backend ยังไม่ส่ง can_decide_on_web = ถือว่าตัดสินได้เฉพาะใบไม่มีหัวหน้า (พฤติกรรมเดิม)
  canDecideOnWeb = (item) => (item.can_decide_on_web === undefined ? !item.approver_name : !!item.can_decide_on_web);

  renderRequestAction = (item) => {
    if (item.status === "pending") {
      if (!this.canDecideOnWeb(item)) {
        return (
          <div>
            {this.badge("warn", t("att_req_status_pending"))}
            {item.pending_workdays > 0 ? <div className="tt-mini mt-1">{t("att_req_pending_days").replace("{n}", item.pending_workdays)}</div> : null}
          </div>
        );
      }
      if (!this.can.approve) return this.badge("warn", t("att_req_status_pending"));
      return (
        <div className="d-flex gap-2">
          <button className="tt-btn tt-ok tt-sm" onClick={() => this.Approve(item)}>{t("approve")}</button>
          <button className="tt-btn tt-rj tt-sm" onClick={() => this.OpenReject(item)}>{t("reject")}</button>
        </div>
      );
    }
    return this.badge(REQUEST_BADGE[item.status] || "none", t(`att_req_status_${item.status}`));
  };

  // คอลัมน์ผู้อนุมัติ / ความเห็น / เหตุผลปฏิเสธ
  renderApprover = (item) => {
    const codeLabel = REJECT_REASON_CODES.includes(item.reject_reason_code) ? t(`att_reject_code_${item.reject_reason_code}`) : "";
    // อนุมัติ 2 ระดับ (ระดับ 1 → ระดับ 2): แสดงผู้อนุมัติทั้งสองระดับ + ขั้นปัจจุบันของคำขอที่ยังรออยู่
    const twoLevel = !!item.has_level2 || item.approval_level === 2;
    const level1Done = item.approval_level === 2;
    return (
      <div className="text-14">
        {twoLevel ? (
          <div data-testid="att-approver-levels">
            <div>
              <span className="tt-mini">{t("att_req_level1")}: </span>
              {item.level1_approver_name ? <b>{item.level1_approver_name}</b> : "-"}
              {level1Done ? <span className="tt-mini" style={{ color: "var(--tt-ok)" }}> ✓</span> : null}
            </div>
            <div>
              <span className="tt-mini">{t("att_req_level2")}: </span>
              {item.level2_approver_name ? <b>{item.level2_approver_name}</b> : "-"}
            </div>
            {item.status === "pending" ? (
              <div className="tt-mini" style={{ color: "var(--tt-warn)" }}>{t("att_req_current_level").replace("{n}", item.approval_level === 2 ? 2 : 1)}</div>
            ) : null}
            {level1Done && item.level1_comment ? <div className="tt-mini">{t("att_req_level1")}: {item.level1_comment}</div> : null}
          </div>
        ) : (
          <div>
            {item.approver_name ? <b>{item.approver_name}</b> : <span className="tt-mini">{item.status === "pending" ? t("att_req_no_approver") : "-"}</span>}
          </div>
        )}
        {item.is_override && item.decided_by_name ? (
          <div className="tt-mini" style={{ color: "var(--tt-warn)" }}>{t("att_req_override_by")} {item.decided_by_name}</div>
        ) : null}
        {item.approver_comment ? <div className="tt-mini">{item.approver_comment}</div> : null}
        {item.status === "rejected" && (codeLabel || item.reject_reason) ? (
          <div className="tt-mini" style={{ color: "var(--tt-crit)" }}>{[codeLabel, item.reject_reason].filter(Boolean).join(" · ")}</div>
        ) : null}
        {item.status === "pending" && item.approver_name && !this.canDecideOnWeb(item) ? <div className="tt-mini">{t("att_req_decided_in_app")}</div> : null}
      </div>
    );
  };

  renderRequests() {
    const { req_status, req_from, req_to, req_q, req_data } = this.state;
    const lang = currentLang();

    return (
      <>
        <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
          <div className="row g-3 align-items-end">
            <div className="col-md-3">
              <label className="form-label text-12 text-secondary mb-1">{t("att_req_status")}</label>
              <Select
                className="form-control w-100"
                options={REQUEST_STATUS_OPTIONS.map((s) => ({ value: s, label: t(`att_req_status_${s}`) }))}
                value={req_status}
                onChange={(v) => this.setState({ req_status: v }, this.GetRequests)}
                placeholder={t(`att_req_status_${REQUEST_STATUS_OPTIONS[0]}`)}
              />
            </div>
            <div className="col-md-5">
              <label className="form-label text-12 text-secondary mb-1">{t("date_range")}</label>
              <div className="d-flex gap-2">
                <DateRangeFields
                  type={lang}
                  className="form-control"
                  fieldStyle={{ flex: 1, minWidth: 0 }}
                  startPlaceholder={t("start_date")}
                  endPlaceholder={t("end_date")}
                  startValue={req_from}
                  endValue={req_to}
                  onChange={({ start, end }) =>
                    this.setState(
                      { req_from: start, req_to: end },
                      // ยิงเมื่อเลือกครบช่วง หรือล้างค่า
                      () => (end || !start) && this.GetRequests()
                    )
                  }
                />
              </div>
            </div>
            <div className="col-md-4">
              <label className="form-label text-12 text-secondary mb-1">{t("att_filter_employee")}</label>
              <input className="form-control" value={req_q} placeholder={t("att_search_placeholder")} onChange={(e) => this.SetReqQ(e.target.value)} />
            </div>
          </div>
        </div>

        <div className="tt-tblwrap">
          <table className="tt-tbl" style={{ minWidth: 1000 }}>
            <thead>
              <tr>
                <th>{t("att_req_sent_at")}</th>
                <th>{t("att_filter_employee")}</th>
                <th>{t("att_req_work_date")}</th>
                <th>{t("att_req_type")}</th>
                <th>{t("att_req_original")}</th>
                <th>{t("att_req_requested")}</th>
                <th>{t("reason")}</th>
                <th>{t("att_req_evidence")}</th>
                <th>{t("att_req_approver")}</th>
                <th style={{ position: "sticky", right: 0, boxShadow: "-2px 0 4px rgba(0,0,0,.05)" }}>{t("att_req_action")}</th>
              </tr>
            </thead>
            <tbody>
              {!req_data.length ? (
                <tr><td colSpan="10" className="text-center text-secondary py-5">{t("no_data")}</td></tr>
              ) : (
                req_data.map((item) => (
                  <tr key={item.uid} style={item.status !== "pending" ? { opacity: 0.6 } : undefined}>
                    <td>{fmtDayMonthTime(item.created_at)}</td>
                    <td>{[item.technician?.code, item.technician?.name].filter(Boolean).join(" · ") || "-"}</td>
                    <td>{fmtDateLocal(item.work_date, lang)}</td>
                    <td>
                      {CORRECTION_TYPES.includes(item.type) ? t(`att_type_${item.type}`) : item.type || "-"}
                      {item.type === "cannot_log" ? <div>{this.badge("p", t("att_backdate_badge"))}</div> : null}
                      {item.work_location_text ? <div className="tt-mini mt-1">{t("att_work_location")}: {item.work_location_text}</div> : null}
                    </td>
                    <td>{this.renderTimePair(item.original_in_at, item.original_out_at)}</td>
                    <td>{this.renderTimePair(item.req_in_at, item.req_out_at, true)}</td>
                    <td style={{ whiteSpace: "normal", minWidth: 140, maxWidth: 200 }}>{item.reason || "-"}</td>
                    <td>
                      {item.attachment_count > 0 ? (
                        <a href="#attachment" onClick={(e) => { e.preventDefault(); this.OpenAttachment(item); }}>📷 {formatNumber(item.attachment_count)}</a>
                      ) : "-"}
                    </td>
                    <td style={{ whiteSpace: "normal", minWidth: 150, maxWidth: 200 }}>{this.renderApprover(item)}</td>
                    <td style={{ position: "sticky", right: 0, background: "#fff", boxShadow: "-2px 0 4px rgba(0,0,0,.05)" }}>{this.renderRequestAction(item)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <p className="tt-mini mt-2">{t("att_req_hint")}</p>
      </>
    );
  }

  renderSettings() {
    const { settings, reminder_supported } = this.state;
    const fields = [
      ["accuracy_threshold_m", "att_setting_accuracy", "att_setting_accuracy_hint", t("att_meter")],
      ["auto_close_hours", "att_setting_auto_close", "att_setting_auto_close_hint", t("att_hour")],
      ["correction_backdate_days", "att_setting_backdate", "att_setting_backdate_hint", t("att_day")],
    ];
    return (
      <div className="bg-white rounded-4 shadow-sm p-4" style={{ maxWidth: 640 }}>
        <div className="d-flex flex-column gap-4">
          {fields.map(([key, label, hint, unit]) => (
            <div key={key}>
              <label className="form-label text-14 fw-bold text-dark mb-1">{t(label)}</label>
              <div className="d-flex align-items-center gap-2" style={{ maxWidth: 260 }}>
                <input
                  className="form-control"
                  type="number"
                  min="1"
                  max={SETTING_MAX[key]}
                  step="1"
                  value={settings[key]}
                  onChange={(e) => this.setState({ settings: { ...settings, [key]: e.target.value } })}
                />
                <span className="tt-mini">{unit}</span>
              </div>
              <div className="tt-mini mt-1">{t(hint)}</div>
            </div>
          ))}

          {reminder_supported ? (
            <div className="border-top pt-3">
              <label className="form-label text-14 fw-bold text-dark mb-1">{t("att_setting_reminder")}</label>
              <div className="form-check d-flex align-items-center gap-2 mt-1">
                <input
                  className="form-check-input mt-0 pointer"
                  type="checkbox"
                  id="attReminderEnabled"
                  checked={!!settings.reminder_enabled}
                  onChange={(e) => this.setState({ settings: { ...settings, reminder_enabled: e.target.checked } })}
                />
                <label className="form-check-label pointer" htmlFor="attReminderEnabled">{t("att_setting_reminder_enabled")}</label>
              </div>
              {[
                ["reminder_after_workdays", "att_setting_reminder_after", t("att_workday")],
                ["reminder_hour", "att_setting_reminder_hour", t("att_hour_clock")],
              ].map(([key, label, unit]) => (
                <div key={key} className="mt-3">
                  <label className="form-label text-14 text-dark mb-1">{t(label)}</label>
                  <div className="d-flex align-items-center gap-2" style={{ maxWidth: 260 }}>
                    <input
                      className="form-control"
                      type="number"
                      min={REMINDER_RANGE[key][0]}
                      max={REMINDER_RANGE[key][1]}
                      step="1"
                      disabled={!settings.reminder_enabled}
                      value={settings[key]}
                      onChange={(e) => this.setState({ settings: { ...settings, [key]: e.target.value } })}
                    />
                    <span className="tt-mini">{unit}</span>
                  </div>
                </div>
              ))}
              <div className="tt-mini mt-2">{t("att_setting_reminder_hint")}</div>
            </div>
          ) : null}
        </div>
        <div className="d-flex justify-content-end mt-4">
          <button className="btn btn-primary px-4 py-2 fw-bold rounded-3" onClick={this.SaveSettings}>{t("save")}</button>
        </div>
      </div>
    );
  }

  render() {
    const { tab, pending_count, modal_reject, reject_reason, modal_override, override_in, override_out, override_out_next, override_reason } = this.state;
    const tabs = [
      ["report", t("att_tab_report")],
      ["requests", t("att_tab_requests")],
      ...(this.can.setting ? [["settings", t("att_tab_settings")]] : []),
    ];

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3 tt-page">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("att_menu_attendance")}</h3>
              <div className="text-secondary text-14">{t("att_desc")}</div>
            </div>
            {this.can.export && tab === "report" ? (
              <div className="d-flex gap-2">
                <button className="btn btn-white border px-3 py-2 fw-bold rounded-3" onClick={this.Export}>⬇ {t("att_export_btn")}</button>
                <button className="btn btn-white border px-3 py-2 fw-bold rounded-3" onClick={this.ExportTxt}>⬇ {t("att_export_txt_btn")}</button>
              </div>
            ) : null}
          </div>

          <div className="tt-subtabs">
            {tabs.map(([key, label]) => (
              <button key={key} className={tab === key ? "on" : ""} onClick={() => this.SwitchTab(key)}>
                {label}
                {key === "requests" && pending_count > 0 ? (
                  <span className="tt-badge tt-b-crit ms-2">{formatNumber(pending_count)}</span>
                ) : null}
              </button>
            ))}
          </div>

          {tab === "report" ? this.renderReport() : null}
          {tab === "requests" ? this.renderRequests() : null}
          {tab === "settings" && this.can.setting ? this.renderSettings() : null}
        </div>

        <Modal show={modal_override} onHide={() => this.setState({ modal_override: false })} centered contentClassName="border-0 rounded-4 shadow-lg">
          <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
            <h5 className="fw-bold mb-0 text-dark">{t("att_override_title")}</h5>
          </Modal.Header>
          <Modal.Body className="p-4 bg-white">
            {this.state.detail?.log ? (
              <div className="text-14 mb-3">
                <b>{this.state.detail.log.technician?.name || "-"} ({this.state.detail.log.technician?.code || "-"})</b> · {fmtDateLocal(this.state.detail.log.work_date, currentLang())}
              </div>
            ) : null}
            <div className="row g-3">
              <div className="col-6">
                <label className="form-label text-14 text-dark mb-2">{t("att_override_in")}</label>
                <input type="time" className="form-control" value={override_in} onChange={(e) => this.setState({ override_in: e.target.value })} />
              </div>
              <div className="col-6">
                <label className="form-label text-14 text-dark mb-2">{t("att_override_out")}</label>
                <input type="time" className="form-control" value={override_out} onChange={(e) => this.setState({ override_out: e.target.value })} />
                <div className="form-check mt-2">
                  <input className="form-check-input pointer" type="checkbox" id="attOverrideNext" checked={override_out_next} onChange={(e) => this.setState({ override_out_next: e.target.checked })} />
                  <label className="form-check-label pointer text-14" htmlFor="attOverrideNext">{t("att_override_next_day")}</label>
                </div>
              </div>
              <div className="col-12">
                <label className="form-label text-14 text-dark mb-2">
                  {t("att_override_reason")} <span className="text-danger">*</span>
                </label>
                <textarea className="form-control" rows={3} maxLength={2000} value={override_reason} onChange={(e) => this.setState({ override_reason: e.target.value })} />
              </div>
            </div>
            <div className="tt-mini mt-3">{t("att_override_hint")}</div>
          </Modal.Body>
          <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
            <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_override: false })}>
              {t("cancel")}
            </button>
            <button className="btn px-4 py-2 rounded-3 fw-bold text-white" style={{ background: "#2A55E5" }} onClick={this.SaveOverride}>
              {t("save")}
            </button>
          </Modal.Footer>
        </Modal>

        <Modal show={modal_reject} onHide={() => this.setState({ modal_reject: false, reject_item: null })} centered contentClassName="border-0 rounded-4 shadow-lg">
          <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
            <h5 className="fw-bold mb-0 text-dark">{t("att_reject_title")}</h5>
          </Modal.Header>
          <Modal.Body className="p-4 bg-white">
            <label className="form-label text-14 text-dark mb-2">
              {t("att_reject_reason")} <span className="text-danger">*</span>
            </label>
            <textarea className="form-control" rows={3} value={reject_reason} onChange={(e) => this.setState({ reject_reason: e.target.value })} />
          </Modal.Body>
          <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
            <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_reject: false, reject_item: null })}>
              {t("cancel")}
            </button>
            <button className="btn btn-danger px-4 py-2 rounded-3 fw-bold text-white" onClick={this.Reject}>
              {t("reject")}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
